export function hhMmToMinutes(value) {
  if (value == null || value === "") return null;
  const match = String(value).trim().match(/^(\d{1,2}):(\d{2})/);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (
    !Number.isFinite(hours) ||
    !Number.isFinite(minutes) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    return null;
  }
  return hours * 60 + minutes;
}

export function isDeliveryTillBeforeOrAtStartTime(deliveryTill, startTime) {
  const tillMins = hhMmToMinutes(deliveryTill);
  const startMins = hhMmToMinutes(startTime);
  if (tillMins == null || startMins == null) return false;
  return tillMins <= startMins;
}

export function resolveTourStartTimeForDeparture(tour, departure) {
  const timings = tour?.ToursDeliveryTimings || tour?.delivery_timing_configs || [];
  if (!Array.isArray(timings) || !timings.length) return null;
  const dep = String(departure || "").trim().toLowerCase();
  const match = timings.find(
    (t) => String(t?.delivery_timing || "").trim().toLowerCase() === dep
  );
  return (match || timings[0])?.start_time || null;
}
